import { Tag, theme } from 'antd';
import type React from 'react';
import type { RequestStatus } from '../graphql/generated/graphql.ts';
import { findRequestStatusMetadata } from '../utils/enumHelpers';

export const RequestStatusBadge: React.FC<{
  status: RequestStatus;
}> = ({ status }) => {
  const { token } = theme.useToken();
  const { color, translation, iconType: IconComponent } = findRequestStatusMetadata(status, token);

  return (
    <Tag color={color} icon={<IconComponent />}>
      {translation}
    </Tag>
  );
};
